export interface RLFProps {
  name: string;
}

export const getRLFilterRequest = (event: RLFProps) => {
  return {
    ...(event?.name
      ? {
          Nombre: event?.name,
        }
      : {}),
  };
};
